module.exports = __webpack_public_path__ + "static/media/background.b6a61e30.png";